import { Grid } from "@mui/material";
import { useEffect } from "react";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import TiempoClase from "../../components/Form/Fields/TiempoClase";
import ClaseActivaCardImg from "../../components/UmmIApps/Cards/ClaseActivaCardImg.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const ClaseActivaPage = () => {
  const {
    nivelId,
    materiaId,
    promptData,
    setPromptData,
    handleBack,
    handleInitialPromptData,
    setTextoInicial,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema &&
    promptData.tiempo_clase &&
    isOAAdded
  );
  const colorIconBack = "#278C62";

  useEffect(() => {
    const init = {
      tiempo_clase: "",
      objetivos: [],
      materia: "",
      tema: "",
      nivel: "",
      caracterizacion: "",
      condiciones_contexto: "",
    };
    handleInitialPromptData(init, "planificacion_clase_activa");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti.  Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={ClaseActivaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title="Clase Activa"
        description="Diseña clases dinámicas y participativas que involucren a los estudiantes en su propio proceso de aprendizaje, fomentando la participación y el interés por la materia."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TemaClase />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TiempoClase promptData={promptData} setPromptData={setPromptData} />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <CondicionesContexto />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Caracterizacion />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default ClaseActivaPage;
